import { render, staticRenderFns } from "./field_promotion_code.vue?vue&type=template&id=428dc5ae"
import script from "./field_promotion_code.vue?vue&type=script&lang=js"
export * from "./field_promotion_code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports